import { Grid } from "@mui/material";
import Header from "../../../components/custom/Header";
import { styled } from "@mui/system";
import { useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import Dialog from "../../../components/custom/Dialog";
import { createUser } from "../../../services/userService";
import { useMutation } from "react-query";
import UserForm from "../UserForm";

const StyledContainer = styled(Grid)`
  width: 100%;
  height: 100%;
`;

const AddUser = () => {
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [message, setMessage] = useState("");
  const navigate = useNavigate();
  const formikRefAddUser = useRef(null);
  const [showOk, setShowOk] = useState(false);
  const { mutate } = useMutation(createUser, {
    onSettled: (data, error, variables, context) => {
      if (error) {
        setShowOk(true);
        setMessage(error?.response?.data?.error || error?.response?.data);
      } else {
        setShowOk(true);
        setMessage(
          "User has been successfully created. An activation email has been to his email address."
        );
        // setTimeout(() => {
        //   setIsDialogOpen(false);
        //    navigate(-1);
        // }, 1000);
      }
    },
  });
  const user = JSON.parse(window.sessionStorage.getItem("user"));

  return (
    <>
      <StyledContainer sx={{ p: { xs: 2, md: 10 } }}>
        <Header name="Add user" />

        <UserForm
          formikRef={formikRefAddUser}
          onSubmit={async () => {
            setMessage("Creating user... please wait...");
            setIsDialogOpen(true);
            let data = {
              firstName: formikRefAddUser?.current?.values?.firstName,
              lastName: formikRefAddUser?.current?.values?.lastName,
              password: formikRefAddUser?.current?.values?.password,
              userName: formikRefAddUser?.current?.values?.userName,
              role: { id: 3, version: 0, description: "user" },
              email: formikRefAddUser?.current?.values?.email,
              publisherId: user?.publisherId,
            };
            mutate(data);

            // createUser(data)
            //   .then(async (data) => {
            //     setMessage("User created");
            //     navigate(-1);
            //   })
            //   .catch((error) => setMessage(error.message));
          }}
        />
      </StyledContainer>
      <Dialog
        showOk={showOk}
        showButton={false}
        action={() => {
          setShowOk(false);
          setIsDialogOpen(false);
          navigate(-1);
        }}
        onClose={() => {
          setShowOk(false);
          setIsDialogOpen(false);
        }}
        open={isDialogOpen}
      >
        {message}
      </Dialog>
    </>
  );
};

export default AddUser;
